import jwtDecode from 'jwt-decode';

const SecondsForExpirationAction = 20;
const SecondsForAutoRefresh = 300;

let isAutoRefreshing = false;

function secondsLeftToTokenExpiration(apiToken) {
    const decodedToken = jwtDecode(apiToken);
    const dateNowSeconds = Date.now() / 1000;
    return decodedToken.exp - dateNowSeconds;
}

function isTokenExpiredSoon(apiToken) {
    return secondsLeftToTokenExpiration(apiToken) <= SecondsForExpirationAction;
}

function isTokenInAutoRefreshWindow(apiToken) {
    const secondsLeft = secondsLeftToTokenExpiration(apiToken);
    return secondsLeft > SecondsForExpirationAction && secondsLeft <= SecondsForAutoRefresh;
}

export function checkTokenExpiration(getTokenFromState, onTokenExpiration, autoRefreshAction?) {
    return (dispatch, getState) => {
        const apiToken = getTokenFromState(getState());
        if (!apiToken) {
            return;
        }

        if (isTokenExpiredSoon(apiToken)) {
            dispatch(onTokenExpiration);
            return;
        }

        if (autoRefreshAction && !isAutoRefreshing && isTokenInAutoRefreshWindow(apiToken)) {
            isAutoRefreshing = true;
            Promise.resolve(dispatch(autoRefreshAction())).finally(() => {
                isAutoRefreshing = false;
            });
        }
    };
}
